import React, { useContext, useEffect } from "react";
import "./Wallet_History.css";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../../utils/context";

const Wallet_History = ({ subscriptionHistory }) => {
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);

  console.log(subscriptionHistory, "subscriptionHistorysubscriptionHistory");

  const historyData = [
    { id: 1, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 2, price: "200", date: "10-05-2025", time: "10:30 AM" },
    { id: 3, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 4, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 5, price: "200", date: "10-05-2025", time: "10:30 AM" },
    { id: 6, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 7, price: "700", date: "10-05-2025", time: "10:30 AM" },
    { id: 8, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 9, price: "900", date: "12-08-2025", time: "12:30 AM" },
    { id: 10, price: "200", date: "10-05-2025", time: "10:30 AM" },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN"); // 17/02/2026
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    }); // 11:40 AM
  };
  return (
    <div className="wallet-history-container container">
      <h2 className="wallet-history-header">Subscription History</h2>

      <div className="wallet-history-list">
        {subscriptionHistory?.map((item) => (
          <div key={item.id} className="wallet-history-item">
            <div className="history-column">
              <span className="column-label">Price</span>
              <span className="column-value">₹{item.amount}</span>
            </div>

            <div className="history-column text-center">
              <span className="column-label">Start Date</span>
              <span className="column-value">
                {formatDate(item.start_date)}
              </span>
            </div>
            <div className="history-column text-end">
              <span className="column-label">Start Time</span>
              <span className="column-value">
                {formatTime(item.start_date)}
              </span>
            </div>

            <div className="history-column text-center">
              <span className="column-label">End Date</span>
              <span className="column-value">{formatDate(item.end_date)}</span>
            </div>

            <div className="history-column text-end">
              <span className="column-label">End Time</span>
              <span className="column-value">{formatTime(item.end_date)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wallet_History;
